import { Div, Element, Span, reactive, Variable, not } from 'alkali'
import Renderer from 'tools/Renderer'
import Loader from './Loader'
import app from 'app/app'
const app = {}
import Legend from './Legend'

// Generic container class for components. Alkalized revamp of Widget.js.

// Options - none of these are required or expected
// head: passed directly to WidgetHeader as its props, header is rendered if present
//	 title: content to render as title in header (usually text, but can be anything)
//	 icon: font-awesome icon to render left of title, also used for Table of Contents
//	 collapse: enable icon for visually collapsing widget, leaving only the header visible
//	 collapsed: variable to determine initial state for collapse, controls collapse state
//	 legend: icon to control legend visibility
//	 tooltip: text to display for header icon tooltip
// foot: currently just a boolean to determine if footer should be rendered, will likely be expanded
// loader: an overlay with a spinner for async widgets, prevents interaction with widget while visible
// loading: variable to determine initial state of loading, controls loader visibility
// legendOpts: props to pass to Legend elemtn

export class Widget extends Element {
	legend: Legend
	header: WidgetHeader
	body: HTMLElement
	footer: HTMLElement
	loading: Variable<boolean>
	loader: Loader

	created(props) {
		// Since props are all assigned to the element, we use different property names
		// for the options object and the element object (would be nice to have these be unified though)

		// create legend
		if (props.legendOpts) {
			this.legend = new Legend(
				Object.assign(props.legendOpts, {
					showAtStart: !props.head?.collapsed?.valueOf(),
				})
			)
		}

		if (props.head) {
			if (props.head.legend && this.legend) props.head.legend = this.legend

			if (props.dataset == null) {
				props.dataset = {
					name: props.head.title || props.head.titleText,
					tocIcon: props.head.icon,
				}
			}
		}
		this.header = props.head ? new WidgetHeader(props.head) : undefined

		this.body = new Div('.widget-body', {
			display: !props.head?.collapsed?.valueOf(),
			content: props.content,
		})
		props.content = null

		this.footer = props.foot ? new WidgetFooter(props.foot) : undefined

		this.loading = reactive(props.loader || false)
		this.loader = new Loader('.widget-loader', { loading: this.loading })

		this.body.append(this.legend)

		this.append([this.header, this.body, this.footer, this.loader])
	}
}

class WidgetHeader extends Div('.widget-header') {
	collapsed: Variable<boolean>
	controls: HTMLElement
	debug: any
	headerTitle: HTMLElement
	icons: HTMLElement
	legend: Legend
	textHidden: Variable<boolean>
	titleText: HTMLElement
	titleIcon: HTMLElement

	created(props) {
		// Title and icon
		this.headerTitle = new Div('.widget-title')
		this.titleText = new Div('.title-text', {
			content: props.title || props.titleText,
		})
		const iconProps = props.tooltip
			? {
					onmouseenter: e => window.tooltip.show(props.tooltip, event),
					onmouseleave: e => window.tooltip.hide(),
			  }
			: {}
		this.titleIcon = props.icon ? new Div(`.title-icon.fa.${props.icon}`, iconProps) : undefined
		this.headerTitle.append([this.titleIcon, this.titleText])

		// Blank div for injecting arbitrary controls
		this.controls = new Div('.widget-controls')

		// Icons
		this.icons = new Div('.widget-icons')
		this.icons.prepend(
			Span('.widget-debug.fa.fa-fw.fa-bug', {
				title: 'Log debug object to console.',
				display: props.debug && app.user.permissions.permitFeature('Debug'),
				onclick: e => console.log('DEBUG:', this.debug || this.parentElement),
			})
		)
		if (props.hideText) {
			this.textHidden = reactive(props.hideText != null ? props.hideText : false)
			this.icons.append(
				Span('.widget-hide-text.fa.fa-fw', {
					title: 'Hide text fields.',
					onclick: e => this.textHidden.put(!this.textHidden.valueOf()),
					classes: {
						'fa-ellipsis-h': not(this.textHidden),
						'fa-ellipsis-v': this.textHidden,
					},
				})
			)
		}
		if (props.collapse) {
			this.collapsed = reactive(props.collapsed != null ? props.collapsed : false)
			this.icons.append(
				Span('.widget-collapse.fa.fa-fw', {
					title: 'Show/hide this widget.',
					onclick: e => {
						this.collapsed.put(!this.collapsed.valueOf())
					},
					classes: {
						'fa-chevron-down': not(this.collapsed),
						'fa-chevron-right': this.collapsed,
					},
				})
			)
		}
		if (props.legend) {
			this.addLegendIcon(props.legend)
		}

		this.append([this.headerTitle, this.controls, this.icons])
	}

	addLegendIcon(legend) {
		return this.icons.prepend(
			Span('.fa.fa-fw', {
				classes: {
					'fa-toggle-on': legend.show,
					'fa-toggle-off': not(legend.show),
				},
				display: not(this.collapsed),
				title: 'Toggle legend',
				onclick: event => legend.show.put(!legend.show.valueOf()),
			})
		)
	}

	attached() {
		if (this.collapsed) {
			new Renderer({
				element: this,
				variable: this.collapsed,
				renderUpdate: collapsed => {
					if (collapsed) {
						$(this.parentElement.body).slideUp(250)
						$(this.parentElement.footer).slideUp(250)
					} else {
						$(this.parentElement.body).slideDown(250)
						$(this.parentElement.footer).slideDown(250)
					}
				},
			})
		}
	}
}

class WidgetFooter extends Div('.widget-footer') {
	leftSide: any
	rightSide: any

	created(props) {
		if (!props.content) {
			this.leftSide = new Div('.left-side')
			this.rightSide = new Div('.right-side')
			this.append(this.leftSide, this.rightSide)
		}
	}
}
export default Widget.defineElement('doc-widget.widget-alkali')

// class WidgetDialog extends Div('.widget-dialog-wrapper') {
//	 created(props) {
//		 this.container = this.append(
//			 Div('.widget-dialog', [
//				 Div('.widget-dialog-close.btn.btn-xs.btn-default.fa.fa-times', {
//					 onclick: (event) => this.hide()
//				 })
//			 ])
//		 )
//		 this.$ = $(this)
//		 this.container.$ = $(this.container)
//		 this.header = this.container.append(
//			 Div('.widget-dialog-header')
//		 )
//		 this.body = this.container.append(
//			 Div('.widget-dialog-body')
//		 )
//	 }

//	 show(body, header) {
//		 this.header.innerHTML = ''
//		 this.body.innerHTML = ''
//		 this.header.append(header)
//		 this.body.append(body)
//		 if (this.parentElement.clientHeight < 500)
//			 this.parentElement.style.height = '500px'
//		 this.$.velocity('fadeIn', {
//			 duration: 250,
//			 complete: () => {
//				 this.container.$.velocity('slideDown', {
//					 slideDown: 250,
//					 complete: () => {
//						 const pos = this.container.$.offset().top
//						 if (pos < 100) {
//							 let newPos = 100 - pos
//							 this.container.$.velocity({
//								 translateY: newPos + 'px'
//							 })
//						 }
//					 }
//				 })
//			 }
//		 })
//	 }

//	 hide() {
//		 this.container.$.velocity('slideUp',{
//			 duration: 200,
//			 complete: () => {
//				 this.$.velocity('fadeOut', {
//					 duration: 150
//				 })
//				 this.container.style.cssText = ''
//				 this.parentElement.style.height = 'auto'
//			 }
//		 })
//	 }
//	 onclick(event) { this.hide() }
// }
